var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Button, Input, FormGroup } from 'reactstrap';
import cxs from 'cxs';
var styles = {
    display: cxs({
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    })
};
var GroupNameSection = /** @class */ (function (_super) {
    __extends(GroupNameSection, _super);
    function GroupNameSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            editing: false,
            inputValue: _this.props.slot.groupName || ''
        };
        _this.handleEdit = function () {
            _this.setState({
                editing: true,
                inputValue: _this.props.slot.groupName || ''
            });
        };
        _this.handleCancel = function () {
            _this.setState({ editing: false });
        };
        _this.handleSave = function () {
            var name = _this.state.inputValue.trim() || null;
            _this.props.onSave(name);
            _this.setState({ editing: false });
        };
        _this.handleInputChange = function (e) {
            _this.setState({ inputValue: e.target.value });
        };
        return _this;
    }
    GroupNameSection.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.slot.groupName !== this.props.slot.groupName) {
            this.setState({
                inputValue: this.props.slot.groupName || '',
                editing: false
            });
        }
    };
    GroupNameSection.prototype.render = function () {
        var slot = this.props.slot;
        var _a = this.state, editing = _a.editing, inputValue = _a.inputValue;
        if (editing) {
            return (React.createElement(FormGroup, null,
                React.createElement(Input, { type: "text", value: inputValue, onChange: this.handleInputChange, placeholder: "Nombre del grupo...", bsSize: "sm" }),
                React.createElement("div", { className: "mt-2" },
                    React.createElement(Button, { color: "primary", size: "sm", onClick: this.handleSave }, "Guardar"),
                    ' ',
                    React.createElement(Button, { color: "secondary", size: "sm", outline: true, onClick: this.handleCancel }, "Cancelar"))));
        }
        return (React.createElement("div", { className: styles.display },
            React.createElement("span", null, slot.groupName || React.createElement("em", { className: "text-muted" }, "Sin nombre de grupo")),
            React.createElement(Button, { color: "link", size: "sm", onClick: this.handleEdit }, "Editar")));
    };
    GroupNameSection = __decorate([
        observer
    ], GroupNameSection);
    return GroupNameSection;
}(Component));
export default GroupNameSection;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/components/GroupNameSection.tsx
// module id = 1616
// module chunks = 0